var _style, _circle, _circle2, _circle3, _circle4, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 150,
    viewBox: "0 0 420 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n.check_path{\n  stroke-dasharray: 100;\n  stroke-dashoffset: 100;\n  animation: dash 1s linear forwards;\n}\n\n@keyframes dash {\n  to {\n    stroke-dashoffset: 0;\n  }\n}    \n.wave{\n    animation:waves 3s infinite ease-in-out;\n    transform-origin: 50% 48%;\n}\n.delay1{\n    animation-delay: 1s;\n}\n\n.delay2{\n    animation-delay: 2s;\n}\n@keyframes waves{\n    0%{\n        fill-opacity: 0;\n        transform: scale(0);\n    }\n    25%{\n        fill-opacity:0.5;\n        transform: scale(1.255);\n    }\n    50%{\n        fill-opacity:0.75;\n        transform: scale(1.5);\n    }\n    75%{\n        fill-opacity:1;\n        transform: scale(1.75);\n    }\n    100%{\n       fill-opacity: 0;\n       transform: scale(2);\n    }\n}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "wave",
    cx: 209,
    cy: 71,
    r: 36,
    fill: "rgba(0,208,156,0.2)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "wave delay1",
    cx: 209,
    cy: 71,
    r: 36,
    fill: "rgba(0,208,156,0.2)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "wave delay2",
    cx: 209,
    cy: 71,
    r: 36,
    fill: "rgba(0,208,156,0.2)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 71,
    r: 36,
    fill: "#00D09C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "check_path",
    d: "M192.5 74.5L203 86.5L229 60.5",
    stroke: "#ffffff",
    strokeWidth: "8px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.09284bc5411ac9781aefef13abc045c4.svg";
export { ForwardRef as ReactComponent };